import React,{useState,useEffect,useRef} from "react";
import {addCandidateRelationship} from './api/Calls';
import {getSingleCondidate,getNewFamilyList} from '../../../Redux/Actions/newJoinerAction';
import { useDispatch,useSelector } from "react-redux";
import {updateCandidateRelationship} from '../../HR/onboarding/api/Calls'
import moment from 'moment';

const AddFamilyModel = ({email,edit,setSelected}) =>{
    console.log('edit')
    console.log(edit)
    const dispatch = useDispatch();
    const {onecondidate} = useSelector((state) => state.NewJoinerReducer);
    console.log('onecondidate')
    console.log(onecondidate)
    const cancelRef = useRef(null);
    const initialValues = {
      age: "",
      name: "",
      relationship: "",
      occupation:"",
      dob:""
    };
    const [values, setValues] = useState(initialValues);
    const [age,setAge] =useState('')
    const handleChange =  (e) => {
        const { name, value } = e.target;
        console.log(value)
        setValues({ ...values, [name]: value });
        if(values.dob){
            var today = new Date();
           // console.log(today)
            var birthDate = new Date(`${moment(values.dob).format('YYYY-MM-DD')}`);  // create a date object directly from `dob1` argument
           // console.log(birthDate)
            var age_now = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
            {
                age_now--;
            }
            setAge(age_now)
           // console.log(age_now);
      
          }else{
            setAge('');
          }
      };
    console.log('age')
    console.log(age);
    useEffect(()=>{
        if(edit){setValues(edit)}
        if(edit){setAge(edit.age)}
        dispatch(getSingleCondidate(email))
        
        
    },[email,edit])
    const handleCancel = () => {
        setSelected(null);
        setAge('');
        setValues(initialValues);
    };

      const handleSubmit = (e) =>{
        console.log(onecondidate)
        e.preventDefault();
        if(values.name ==='' || age ==='' || values.relationship ==='' || values.occupation ==='' || values.dob ===''){
            return alert('All field is required !');
        }else{
            const updatedData = {
                user_id:onecondidate?.condidateID,
                age:age,
                name:values.name,
                relationship:values.relationship,
                dob:values.dob,
                occupation:values.occupation,
            }
            addCandidateRelationship(updatedData,onecondidate?.condidateID).then((res) =>{
                if (res.status) {
                    setValues(initialValues)
                    cancelRef.current.click();
                    dispatch(getNewFamilyList(onecondidate?.condidateID));
                    return alert(res.msg)
                }else{
                    return alert(res.msg)
                }
            })
        }
      }
      const handleUpdateInfo = (e) =>{
        
        e.preventDefault();
        if(values.name ==='' || age ==='' || values.relationship ==='' || values.occupation ==='' || values.dob ===''){
            return alert('All field is required !');
        }else{
            const updatedData = {
                age:age,
                name:values.name,
                relationship:values.relationship,
                dob:values.dob,
                occupation:values.occupation,
                updated_by:onecondidate?.condidateID
            }
            updateCandidateRelationship(updatedData,edit.id).then((res) =>{
                if (res.status) {
                    setValues(initialValues)
                    cancelRef.current.click();
                    dispatch(getNewFamilyList(onecondidate?.condidateID));
                    return alert(res.msg)
                }else{
                    return alert(res.msg)
                }
            })
        }
      }
    return(
        <>
        <div className="modal fade" id="addfamilydetail" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                  <i className="icon icon-cross" ref={cancelRef} onClick={handleCancel}/>
                </button>
                <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{edit ===null?'Add':'Edit'} Family Detail</div>
                
                  <div className="mb-2">
                    <label className="col-form-label">Name <sup className="error_mgs">*</sup></label>
                    <input type="text" className="form-control" id="name" onChange={handleChange} name="name" value={values.name}/>
                  </div>
                  <div className="mb-2">
                    <label className="col-form-label">Relationship <sup className="error_mgs">*</sup></label>
                    <input type="text" className="form-control" id="relationship" onChange={handleChange} name="relationship" value={values.relationship}/>
                  </div>
                  <div className="mb-2 row">
                    <div className="col-md-6"><label className="col-form-label">Date of Birth <sup className="error_mgs">*</sup></label>
                    <input type="date" className="form-control" id="dob" onChange={handleChange} name="dob" value={moment(values.dob).format('yyyy-MM-DD')}/>
                  
                    </div>
                    <div className="col-md-6">
                    <label className="col-form-label">Age </label>
                    <input type="text" className="form-control" id="age" readOnly onChange={handleChange} name="age" value={age}/>
                  </div>
                   </div>
                  <div className="mb-4">
                    <label className="col-form-label">Occupation <sup className="error_mgs">*</sup></label>
                    <input type="text" className="form-control" id="occupation" onChange={handleChange} name="occupation" value={values.occupation}/>
                  </div>
                <div className="modalfooter">
                  <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" ref={cancelRef} onClick={handleCancel}>Cancel</button>
                  <button type="button" onClick={edit === null ? handleSubmit:handleUpdateInfo} className="btn_5 float-end ">{edit === null?'Add':'Update'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    )
}
export default AddFamilyModel;